import React from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import BonosWidget from './BonosWidget';
import BALogo from "./BALogo";


const Home  = () => {
        return (
            <div>

                <div className="bg-circle">
                    <BALogo height={"80%"} width={"80%"} primaryColor={"#FFFFFF"}/>
                </div>    

                <div className="bonos-tiles-section first-title-separator">
                    {/*TO DO: this needs to be a component*/}
                    <div className="text-center title-text home-title">
                        <NavLink tag={Link} to="/opiniones" className="nav-link-dark">
                            <div className="home-title-container">
                                <div className="ban-spain-img__pos">
                                    <img className="ban-spain-img" src={require('./resources/ban-spain.png')} alt="España" />
                                </div>
                                <div className="home-main-title__pos">
                                    LAS MEJORES CASAS DE APUESTAS EN ESPAÑA
                                </div>
                            </div>
                        </NavLink>                        
                    </div>

                    <div className="bonos-tiles-section__bonos">
                        <BonosWidget startPoint={0} endPoint={4} />
                    </div>

                    <div className="bonos-tiles-section__link text-center">
                        {/*<a href={"/bonos"} target="blank" className="md-btn text-center">
                            Ver todas las casa de apuesta
                        </ a>*/}
                        <NavLink tag={Link} to="/bonos">
                            <div> Ver todas las casa de apuestas</ div>
                        </NavLink>
                    </div>
                </div>          

                <div className="welcome-section info-section__grid object-card"> 
                    {/*TO DO: this needs to be a component*/}
                    <div className="opinions-section__opinions info-margin">

                        <div className="title-text-dark  home-title title-sepatator">
                            ¿Cómo aprovechar mejor mi dinero?
                        </div>

                        <div className="opinions-review-txt">
                            En BonosApuesta.com encontramos y negociamos las mejores promociones en apuestas deportivas y de casino:
                            <br />
                            <br />
                            &#8226; Compara las mejores casas de apuestas online<br />
                            &#8226; Beneficiate de nuestros bonos<br />
                            &#8226; Descifra la letra pequeña de casa casa de apuestas<br />
                            &#8226; Triunfa con la mejor oferta del mes                           
                        </div>
                    </div>

                    <div className="opinions-section__bonos">
                        <div>
                            <img className="welcome-img" src={require('./resources/ba-home-banner.png')} alt="Best choice" />
                        </div>
                    </div>
                </div> 

                <div className="why-qa-section info-section-why__grid object-card">
                    {/*TO DO: this needs to be a component*/}
                    <div className="opinions-section__opinions info-second-margin">
                        <div className="img-container">
                            <img className="best-choice-img" src={require('./resources/betting-guy.jpg')} alt="Winning"/>
                        </div>
                    </div>

                    <div className="opinions-section__bonos">
                        <div className="margin-top-neg-40">
                                <div className="title-text-dark  home-title title-sepatator">
                                    ¿Por qué BonosApuesta.com?
                            </div>

                            <div className="opinions-review-txt">
                                Las casas de apuestas suelen utilizar bonos llamativos para conseguir tu registro de cliente, pero algunos de ellos son complicados de canjear (por no decir engañosos). 
                                Ademas, encontrar las mejores promociones de apuesta online te tomaría días.<br />
                                <br />
                                BonosApuesta.com existe para asistir a los lectores en la elección del bono mas rentable o a encontrar la página de apuestas ideal.
                            </ div>
                        </div>

                    </div>
                </div> 

                <div className="section-separator">
                </div>        

                <div className="opinions-about-ba-title">
                    <div className="home-sub-title title-text">
                        ¿En que se basan nuestras valoraciones?
                        </div>
                    <div className="home-pr-txt">
                        Seguimos un criterio riguroso antes de incluir cualquier página de apuestas en nuestra web. No recomendamos sitios
                        de apuesta que no conocemos, o que tengan mala reputación. Además, miramos en detalle los siguientes parámetros clave:
                     </div>
                </div> 

                <div className="section-separator">
                </div>  

                <div className="opinions-about-ba">
                    {/*TO DO: this needs to be a component*/}
                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                               Licencias
                        </div>
                            <div className="home-pr-txt">
                                Todos las paginas web de apuestas que encontraras en BonosApuesta.com cumplen con la normativa y
                                licencias pertinentes del territorio español y de la Dirección General de Ordenación del Juego. En este
                                sentido, desde la aprobación de la Ley de Regulación del Juego, el objetivo principal es beneficiar a que los
                                usuarios disfruten de la posibilidad de jugar y apostar su dinero en internet sin riesgo de ser estafado. Es
                                decir, el apostante siempre va a cobrar todo lo que haya ganado por sus aciertos.
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <g>
                                    <rect fill="none" height="24" width="24" />
                                </g>
                                <g>
                                    <path d="M23,12l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,12l2.44,2.79l-0.34,3.7 l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,12z M10.09,16.72l-3.8-3.81l1.48-1.48l2.32,2.33 l5.85-5.87l1.48,1.48L10.09,16.72z" />
                                </g>
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Calidad de los bonos y ofertas
                        </div>
                            <div className="home-pr-txt">
                                Es raro encontrar una pagina de apuestas que no ofrezca un bono u oferta para nuevos usuarios, el cual es
                                normalmente una apuesta gratis. Las mejores casas de apuestas ofrecen bonos y promociones adicionales a
                                jugadores nuevos o incluso a jugadores ya registrados. No recomendaremos paginas de apuestas que
                                imponen requisitos absurdos a la hora de canjear los bonos para aprovecharse de los usuarios
                                 Experiencia de Usuario (UX)
                                La interface de usuario cubre varios aspectos, desde que tan intuitiva es la web, o hasta que punto el diseño
                                complementa o mejora la experiencia de juego en general.
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Variedad de apuestas y mercados
                        </div>
                            <div className="home-pr-txt">
                                Todas las páginas de apuestas ofrecen cierta variedad de opciones. Desde ligas de divisiones pequeñas hasta
                                grandes eventos deportivos como una mundial de futbol. Siempre examinaremos las opciones de apuesta
                                disponibles. Idealmente, nos gusta ver un buen abanico de apuestas en directo que se actualizan
                                regularmente y opciones de mirar un partido o juego a tiempo real
                        </div>
                        </div>
                    </div>
                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1F1B24" width="24" height="24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Cuotas
                        </div>
                            <div className="home-pr-txt">
                                Apostamos dinero online para ganar. Por ello, queremos asegurarnos de que tendrás las mejores cuotas
                                posibles para tus aciertos. Cuando analizamos las paginas de apuestas, comparamos las cuotas del momento
                                con otras casas de apuestas. Si un sitio tiene cuotas competitivas te lo haremos saber, así como también sino
                                las tiene.
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                        <div className="home-bullet-title title-text">
                                Depósitos y retiros
                        </div>
                            <div className="home-pr-txt">
                                Cuando depositas dinero en una página de apuestas deberías tener un abanico de opciones para ingresarlo.
                                Los depósitos deben ser rápidos, por no decir instantáneos, y seguros. También nos interesa que no existan
                                comisiones al ingresar dinero. Y que las comisiones para retirar sean lo más baja posible.
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Reputación
                            </div>
                            <div className="home-pr-txt">
                                La reputación histórica de una casa de apuestas puede ser tanto una ventaja como una desventaja. Cuando
                                analizamos una web, leemos cientos de comentarios de expertos y de usuarios y haremos un consenso.
                        </div>
                        </div>
                    </div>


                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <g>
                                    <rect fill="none" height="24" width="24" />
                                    <path d="M12,1L3,5v6c0,5.55,3.84,10.74,9,12c5.16-1.26,9-6.45,9-12V5L12,1L12,1z M11,7h2v2h-2V7z M11,11h2v6h-2V11z" />
                                </g>
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Seguridad y fiabilidad
                        </div>
                            <div className="home-pr-txt">
                                Todas las transacciones deben estar protegidas por un sistema de SSL encriptado, y deben contar con una
                                política de privacidad robusta. Nos gusta leernos las políticas de privacidad para asegurarnos de que no hay
                                letra pequeña escondida que pueda afectar la privacidad u seguridad de los usuarios
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" /><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                User Experience(UX)
                        </div>
                            <div className="home-pr-txt">
                                La interface cubre varios aspectos, desde que tan intuitivo es la web, o hasta que punto el diseño complementa o mejora la experiencia de juego en general.
                        </div>
                        </div>
                    </div>


                    <div className="home-about-ba-attr">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Atención al cliente
                        </div>
                            <div className="home-pr-txt">
                                La atención al cliente es un factor de peso dentro de nuestras valoraciones. Debe darse en varios formatos –
                                incluyendo un chat en vivo, email, y teléfono. Idealmente el equipo de atención al cliente debe estar
                                disponible 24/7 para contestar preguntas sobre depósitos, retiros, disputas o cualquier otro tipo de
                                problema que pueda surgir.
                        </div>
                        </div>
                    </div>

                    <div className="home-about-ba-attr home-about-ba-attr-last">
                    </div>

                    <div className="home-about-ba-attr home-about-ba-attr-last">
                        <div className="home-about-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#1F1B24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
                            </svg>
                        </div>
                        <div className="home-about-txt">
                            <div className="home-bullet-title title-text">
                                Características adicionales
                        </div>
                            <div className="home-pr-txt">
                                Finalmente evaluaremos cualquier tipo de opción adicional que ofrezca la página de apuestas y que
                                enriquezcan de manera sustancial la experiencia de juego. Como por ejemplo partidos en streaming, retiros
                                parciales o estadísticas de juego. Mientras mas y mejores características mejor será la valoración final.
                        </div>
                        </div>  
                    </div>

                    <div className="home-about-ba-attr home-about-ba-attr-last">
                    </div>
                </div>
            </div> 
        );
}

export default Home;
